import { FETCHING_INBOUND_CALL_START,
  FETCHING_INBOUND_CALL_SUCCESS} from '../actions/actiontypes'

const INIT_STATE = {
	data:{},
  teams: [],
	completed:false,
}

export default function(state = INIT_STATE, action) {
	switch(action.type){
		case FETCHING_INBOUND_CALL_START:{
			return state;
		}
		case FETCHING_INBOUND_CALL_SUCCESS:{
			return {...state, data:action.payload, teams : action.payload.teams ,completed:true };
		}
		default: {
			return state;
		}
	}
}
